<template>
    <Layout>
        <Titlebar title="Machines" :links="links" />
        <Table :table="table" :row_action="showMachine" />
    </Layout>
</template>

<script>
    import { links } from '@/Mixins'
    import Table from '@/Components/Table'

    export default {
        mixins: [links],
        components: {
            Table
        },
        props: {
            table: {
                type: Object,
                default: {}
            }
        },
        methods: {
            showMachine(id) {
                const link = route('machines.show', id);
                this.$inertia.visit(link);
            }
        },
    }
</script>
